export default "__VITE_ASSET__DGEk7pCd__"